import {json} from '../core/data-source/json.mapper';

export class ViolationRecord {
    @json()
    id: number;

    @json()
    message: string;

    @json({
        value: []
    })
    parameters: string[];
}
